
import { v4 as uuidv4 } from 'uuid';
import { toast } from 'react-toastify';

import { types } from '../types/typesCompras';
import { fetchConToken } from '../../helpers/fetch';
import { initialCreateCompras, initialAddTitles, initialAddItems, initialCalculoTotales } from '../../helpers/compras';

export const iniLoadExpensesList = () => {
    return async (dispatch) => {
        try {
            const resp = await fetchConToken('compras');
            const body = await resp.json();
            if (body.ok) {
                dispatch(comprasLoadList(body.data));
            }
        } catch (error) {
            console.log(error)
        }
    }
}

export const iniCreateCompras = (newDetail = null) => {
    return async (dispatch) => {
        try {

            // if (!newDetail) {
            //     newDetail = await initialCreateCompras();
            // }

            console.log('--newDetail--', newDetail);

            dispatch(comprasLoadDetail(newDetail));

        } catch (error) {
            console.log(error);
            alert(error);
        }
    }
}

export const iniLoadComprasDetail = (compraId) => {
    return async (dispatch) => {
        try {
            const resp = await fetchConToken(`compras/${compraId || 0}`);
            const body = await resp.json();
            if (body.ok) {
                dispatch(comprasLoadDetail(body.data));
            }
        } catch (error) {
            console.log(error)
        }
    }
}

export const iniCreateGastoFromPpto = (newReferencia, infoPpto) => {
    return async (dispatch, getState) => {
        try {

            const { id: idPpto, items: titles } = infoPpto;
            const defaultParamsGastos = getState().general.detail;
            const { listaTiposDocumentos } = getState().general;

            let newGasto = await initialCreateCompras();
            newGasto.referencia = newReferencia;
            newGasto.id_tipo_documento = defaultParamsGastos.id_tipo_documento;
            newGasto.id_forma_pago = defaultParamsGastos.id_forma_pago;
            newGasto.observaciones = defaultParamsGastos.observaciones_compras;
            newGasto.id_moneda = infoPpto.id_moneda;
            newGasto.simbolo = infoPpto.simbolo;
            newGasto.separacion_miles = infoPpto.separacion_miles;
            newGasto.separacion_decimales = infoPpto.separacion_decimales;
            newGasto.id_ppto = idPpto;

            if (newGasto.id_tipo_documento) {
                const foundDoc = listaTiposDocumentos.find(d => d.id === newGasto.id_tipo_documento);
                if (foundDoc) {
                    newGasto.impuesto_porcentaje = parseFloat(foundDoc.impuestos[0].porcentaje_impuesto);
                    newGasto.impuesto_tipo_calculo = foundDoc.impuestos[0].tipo_calculo;
                    newGasto.impuesto_nombre = foundDoc.impuestos[0].nombre_impuesto;
                }
            }

            dispatch(comprasLoadDetail(newGasto));

            let itemsFinales = [];
            for (let i = 0; i < titles.length; i++) {
                const currentTitle = titles[i];

                // add title
                const newIdTitle = uuidv4();
                let newTitle = await initialAddTitles(newIdTitle);
                if (currentTitle) {
                    newTitle.nombre = currentTitle.nombre;
                    newTitle.cantidad = 1;
                    newTitle.dias = 1;
                    newTitle.precio_unitario = currentTitle.total_saldo;
                    newTitle.subtotal = currentTitle.total_saldo;
                    newTitle.id_categoria = currentTitle.id_categoria;
                    newTitle.id_ppto = idPpto;
                    newTitle.id_item_ppto = currentTitle.id;
                    newTitle.items = [];
                }

                // add item to current title
                const titleItems = currentTitle.items.filter(it => it.selected);
                for (let x = 0; x < titleItems.length; x++) {
                    const currentItem = titleItems[x];

                    const newId = uuidv4();
                    let newItem = await initialAddItems(newId, currentTitle.id);
                    if (currentItem) {
                        newItem.nombre = currentItem.nombre;
                        newItem.cantidad = 1;
                        newItem.dias = 1;
                        newItem.precio_unitario = currentItem.total_saldo;
                        newItem.subtotal = currentItem.total_saldo;
                        newItem.id_categoria = currentItem.id_categoria;
                        newItem.id_servicio = currentItem.id_servicio;
                        newItem.id_titulo = newIdTitle;
                        newItem.id_ppto = idPpto;
                        newItem.id_item_ppto = currentItem.id;
                    }

                    newTitle.items.push(newItem);

                }

                itemsFinales.push(newTitle);
            }

            dispatch(comprasLoadItems(itemsFinales));

            const newTotales = await initialCalculoTotales(newGasto, itemsFinales);
            dispatch(comprasUpdateTotales(newTotales));


        } catch (error) {
            console.log(error)
        }
    }
}

export const iniChangeItems = (target, values, item) => {
    return async (dispatch, getState) => {
        try {

            const { detail } = getState().compras;
            const { items } = detail;

            const titleFound = items.filter(t => t.id === item.id_titulo);

            if (titleFound) {
                const newItems = items.map(title => {
                    if (title.id === titleFound[0].id) {
                        const newItems_ = title.items.map(it => {
                            if (it.id === item.id) {
                                let newItem = it;
                                const floatValue = values.floatValue;
                                if (target === 'cantidad') newItem.cantidad = floatValue;
                                if (target === 'dias') newItem.dias = floatValue;
                                if (target === 'precio_unitario') newItem.precio_unitario = floatValue;
                                newItem.subtotal = newItem.cantidad * newItem.dias * newItem.precio_unitario;
                                return newItem;
                            }
                            return it;
                        });

                        return {
                            ...title,
                            items: newItems_
                        };

                    }

                    return title;

                });

                dispatch(comprasLoadItems(newItems));

                const newTotales = await initialCalculoTotales(detail, newItems);
                dispatch(comprasUpdateTotales(newTotales));

            }

        } catch (error) {
            console.log(error)
        }
    }
}

export const iniSave = (form, navigate) => {
    return async (dispatch) => {
        try {
            const resp = await fetchConToken('compras', form, 'POST');
            const body = await resp.json();
            if (body.ok) {
                toast.success(body.msg);

                // const newIds = {
                //     id: body.data.id,
                //     numero: body.data.numero
                // }

                let newDetail = form;
                newDetail.id = body.data.id;
                newDetail.numero = body.data.numero;
                dispatch(comprasLoadDetail(newDetail));

                // dispatch(comprasSetNewIds(newIds));
                // navigate(`/gastos/compras/${body.data.id}`);

            } else {
                toast.warning(body.msg);
            }
        } catch (error) {
            console.log(error);
            toast.error(error);
        }
    }
}

export const iniUpdate = (detail) => {
    return async (dispatch) => {
        try {
            const { id } = detail;
            const resp = await fetchConToken(`compras/${id}`, detail, 'PUT');
            const body = await resp.json();
            if (body.ok) {
                dispatch(comprasLoadDetail(body.data));
                toast.success(body.msg);
            } else {
                toast.warning(body.msg);
            }
        } catch (error) {
            console.log(error);
            toast.error(error);
        }
    }
}

export const iniChangeTotales = () => {
    return async (dispatch, getState) => {
        try {

            const { detail } = getState().compras;
            const { items } = detail;

            const newTotales = await initialCalculoTotales(detail, items);
            dispatch(comprasUpdateTotales(newTotales));

        } catch (error) {
            console.log(error)
        }
    }
}

// export const iniCrearPagos = (formNuevoPago) => {
//     return async (dispatch) => {
//         try {
//             const resp = await fetchConToken('pagos', formNuevoPago, 'POST');
//             const body = await resp.json();
//             if (body.ok) {
//                 toast.success(body.msg);
//                 dispatch(comprasAddPagos(body.data));
//             }
//         } catch (error) {
//             console.log(error)
//         }
//     }
// }

const comprasLoadList = (list) => ({
    type: types.comprasLoadList,
    payload: list
})

export const comprasLoadDetail = (comprasDetail) => ({
    type: types.comprasLoadDetail,
    payload: comprasDetail
})

const comprasLoadItems = (itemList) => ({
    type: types.comprasLoadItems,
    payload: itemList
})

export const comprasUpdateTotales = (totales) => ({
    type: types.comprasUpdateTotales,
    payload: totales
})

export const comprasUpdateSetForm = (newForm) => ({
    type: types.comprasUpdateSetForm,
    payload: newForm
})

export const comprasUpdateInfoDoc = (newInfoDoc) => ({
    type: types.comprasUpdateInfoDoc,
    payload: newInfoDoc
})

export const comprasSetNewProveedor = (newProveedor) => ({
    type: types.comprasSetNewProveedor,
    payload: newProveedor
})

// export const comprasAddPagos = (nuevoPago) => ({
//     type: types.comprasAddPagos,
//     payload: nuevoPago
// })